// Preço anterior que pode aparecer na tela. Nunca o DERIVADO: na Shopee o desconto é a taxa oficial da Affiliate Open
// API (priceDiscountRate) e o original_price que o crawler gravava foi reconstruído dela: a Shopee nunca informou esse
// valor. Mesma regra de backend/canal_whatsapp/desconto_oficial.py (preco_anterior_derivado).
//
// Para todo deal que não é derivado a condição é EXATAMENTE a de antes (original_price > current_price), então
// Mercado Livre, Amazon e ofertas manuais não mudam.

export const precoAnteriorDerivado = (deal) => {
    const d = deal || {};
    return d.derived_reference_price === true
        || d.original_price_source === 'shopee_price_discount_rate'
        || d.discount_source === 'shopee_api_price_discount_rate'
        || String(d.source || '') === 'auto:shopee';
};

// Valor a riscar na tela, ou null.
export const precoAnteriorExibivel = (deal) => {
    const d = deal || {};
    if (precoAnteriorDerivado(d)) return null;
    return d.original_price > d.current_price ? d.original_price : null;
};

// Shopee com desconto oficial: o selo de desconto aparece sozinho, sem preço riscado.
export const descontoOficialSemPrecoAnterior = (deal) => precoAnteriorDerivado(deal) && Number(deal?.discount_percent) > 0;
